module.exports = __webpack_public_path__ + "img/SL-M-100-150.eef2afc4.svg";